import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { User } from '@auth/interfaces/user';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import { setProp } from '@shared/helpers/operators';

@Component({
  name: 'bpc-form-register',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class FormRegister extends Vue {
  @Prop({ type: String, default: null }) readonly recaptcha: string;
  @Prop(String) readonly tenantAlias: string;

  public entity: User = null;
  public entityName = 'user';
  public pluralEntityName = 'users';
  public centerSettingLoaded = false;
  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get savePath() {
    return `auth/${this.tenantAlias}/${this.lang}/sign-up`;
  }

  get configPath() {
    return `${this.tenantId}/config/${this.entityName}/forms/register_user`;
  }

  $refs!: {
    stdRegisterForm: InstanceType<typeof StdForm> & {
      formModel: AnyEntity;
      formProvider: EntityFormProvider;
      saveEntity(formModel: AnyEntity): void;
    };
  };

  get resetRecaptcha() {
    return this.$store.getters['auth/resetRecaptcha'];
  }
  get isLoadingCenterSetting() {
    return this.$store.getters['tenant/isLoading'];
  }

  get formModel() {
    return this.$refs.stdRegisterForm.formModel;
  }

  onInputCustomEvent(event) {
    const eventName = event.eventName;
    switch (eventName) {
      case 'selectedCityFromPostalCode':
        // When updating the zip code field, update the city field
        setProp(this.$refs.stdRegisterForm?.formModel, 'city', event.value);
        break;
      case 'selectedCountryFromPostalCode':
        // When updating the zip code field, update the country field
        setProp(this.$refs.stdRegisterForm?.formModel, 'country', event.value.toLowerCase());
        break;
      default:
        break;
    }
  }

  mounted() {
    this.refreshCenterSetting();
  }

  async refreshCenterSetting() {
    this.centerSettingLoaded = false;
    await this.$store.dispatch('tenant/initializeTenantByAlias', this.tenantAlias);
    this.centerSettingLoaded = true;
  }

  saveEntity() {
    setProp(this.$refs.stdRegisterForm.formModel, 'recaptcha', this.recaptcha);
    this.$refs.stdRegisterForm.saveEntity(this.formModel);
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$store.commit('auth/restartRecaptcha');
    this.$emit('entity-error-saving', e);
  }

  @Watch('resetRecaptcha')
  onChangeResetRecaptcha() {
    if (this.resetRecaptcha === true) {
      this.$emit('reset-recaptcha');
    }
  }
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }
}
